import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    IconButton,
    Box,
    Typography
} from "@mui/material/";
import makeStyles from "@mui/styles/makeStyles";
import CloseIcon from "@mui/icons-material/Close";
import { strings } from "../../../common/i18n";
import styles from "./styles";

/**
 * Leave Audit Dialog Component
 */
export default ({ isModalShown, onClose, onConfirm }) => {
    const classes = makeStyles(styles)();

    return (
        <Dialog
            fullWidth
            maxWidth="xs"
            onClose={onClose}
            open={isModalShown}
        >
            <DialogTitle
                id="leave-audit-dialog-title"
                className={classes.leaveAuditDialogTitle}
            >
                {strings("leaveAuditCreation")}
            </DialogTitle>

            <IconButton
                aria-label="close"
                onClick={onClose}
                className={classes.leaveAuditDialogCloseButton}
            >
                <CloseIcon />
            </IconButton>

            <DialogContent dividers className={classes.leaveAuditDialogContent}>
                <Typography variant="body2" className={classes.leaveAuditDialogText}>
                    {strings("leaveAuditWarning")}
                </Typography>

                <Box
                    className={classes.leaveAuditDialogActions}
                >
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={onClose}
                    >
                        {strings("noStay")}
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onConfirm}
                        autoFocus
                    >
                        {strings("yesLeave")}
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};
